import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_TICKET_DESIGNER_FEATURE_GROUP: FeatureGroup = {
  guid: '1c3edbc2-e6b1-4776-a99d-7930b2d0ff00',
  name: 'development:ticket-designer',
  description: 'Ticket Designer development tool — author ticket layouts',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
